export default "__VITE_ASSET__CxSVjFte__"